import { Alert, Box, Button, Chip, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import Paper from "@mui/material/Paper";
import { Loader } from "../../atoms/Loader";
import {
  getAllSetting,
  deleteSetting,
} from "../../../APICalling/ServiceAPICalling";
import { EXTENSION_IDENTIFIER } from "../../../config/serviceConstant";
import CreateNewSettingModal from "../ModuleSetting/CreateNewSettingModal";
import CreateNewDeleteAttachmentSettingModal from "./CreateNewDeleteAttachmentSettingModal";
import { deleteCronJobOrg, getCronJobsOrg } from "../../../APICalling/Other";
import DeleteAttachmentModal from "./DeleteAttachmentModal";

function RelatedListSetting(props) {
  const {
    children,
    tabIndex,
    index,
    orgid,
    apikey,
    datacenterurl,
    datacenter,
    zuid,
    zapikey,
    ...other
  } = props;

  const [loading, setLoading] = useState(false);
  const [reload, setReload] = useState(false);
  const [settings, setSettings] = useState([]);
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [createNewSettingOpen, setCreateNewSettingOpen] = useState(false);

  const getExecuteCronjob = async () => {
    try {
      let delugeRestApi =
        datacenterurl +
        "/crm/v2/functions/easyattachmentarchiveforzohocrm__executedelete/actions/execute?auth_type=apikey&zapikey=" +
        zapikey;

      let config = {
        orgid,
        apikey,
      };
      let cronJobsOrgResp = await getCronJobsOrg(config);
      let executeJob = cronJobsOrgResp?.data.find(
        (job) => job?.url == delugeRestApi
      );
      if (executeJob?.job_id) {
        return executeJob;
      }
      return {};
    } catch (error) {
      return {};
    }
  };

  const deleteExecuteCronjob = async (jobId) => {
    try {
      let config = {
        orgid,
        apikey,
        settingId: jobId,
      };
      let cronJobsOrgResp = await deleteCronJobOrg(config);
      return cronJobsOrgResp?.data;
    } catch (error) {
      return {};
    }
  };

  const getAllSettings = async ({ headers, params }) => {
    try {
      const settingData = await getAllSetting({ headers, params });

      return settingData?.data || [];
    } catch (error) {
      return [];
    }
  };

  const handleCreateSetting = () => {
    try {
    } catch (error) {
      return [];
    }
  };

  const checkData = async (cb) => {
    let params = { settingType: "deleteAttachment" };
    // params = {};
    let headers = { orgid, apikey, connname: EXTENSION_IDENTIFIER };
    const settings = await getAllSettings({ headers, params });

    const returnData = {
      bool: true,
      settings: settings,
    };
    cb(returnData);
  };

  const deleteSettingById = async (settingId) => {
    try {
      let headers = { orgid, apikey, connname: EXTENSION_IDENTIFIER };
      const settingResp = await deleteSetting({ settingId, headers });

      let executeJob = await getExecuteCronjob();
      if (executeJob?.job_id) {
        await deleteExecuteCronjob(executeJob?.job_id);
      } else {
      }
      setReload((prev) => !prev);
    } catch (error) {}
  };

  useEffect(() => {
    if (orgid && apikey && tabIndex === index) {
      setLoading((prev) => true);
      setCreateNewSettingOpen((prev) => false);
      checkData((returnData) => {
        setSettings((prev) => returnData?.settings);
        setLoading((prev) => false);
      });
    }
  }, [tabIndex, reload]);

  if (tabIndex != index) {
    return <></>;
  }

  if (loading) {
    return <Loader />;
  }

  if (!orgid || !apikey || !datacenterurl) {
    return (
      <>
        Some of the data are missing
        {orgid}-{apikey}-{datacenterurl}
      </>
    );
  }

  const handleClickNewSettingOpen = () => {
    setCreateNewSettingOpen(true);
  };

  const handleRevokeClose = () => {
    setCreateNewSettingOpen(false);
  };

  return (
    <Box
      role="tabpanel"
      hidden={tabIndex !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      sx={{
        // maxWidth: "80%",
        mx: "auto",
      }}
    >
      <Box px={1} py={1}>
        {/* Heading and Create Button */}
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
        >
          <Box>
            <Typography variant="h6" fontWeight="bold">
              Delete Attachment Setting
            </Typography>
            <Typography variant="body2" color="text.secondary" mt={0.5}>
              Automatically remove CRM attachments after a specified period to
              help manage your storage space more efficiently.
            </Typography>
          </Box>
          <Button
            variant="contained"
            color="primary"
            sx={{ textTransform: "none" }}
            onClick={() => handleClickNewSettingOpen()}
          >
            Create Setting
          </Button>
        </Box>

        {/* Info Box */}
        {/* <Alert
          severity="info"
          variant="outlined"
          sx={{
            backgroundColor: "#F1F6FF",
            border: "none",
            borderLeft: "3px solid #1976D2",
            color: "#000",
            fontSize: "14px",
            borderRadius: "4px",
            mb: 5,
          }}
        >
          Attachments will be deleted based on your chosen rule (e.g., older
          than 90 days). This helps reduce storage usage while keeping recent
          files intact.
        </Alert> */}

        <Alert
          severity="warning"
          variant="outlined"
          sx={{
            backgroundColor: "#fef6f0",
            border: "none",
            borderLeft: "3px solid #f57c00",
            color: "#000",
            width: "fit-content",
            fontSize: "14px",
            borderRadius: "4px",
            mb: 5,
          }}
        >
          To safely delete attachments, ensure you select a{" "}
          <strong>custom view</strong> created in the{" "}
          <strong>‘Attachment Logs’</strong> module with the following
          conditions:
          <br />
          1. Select <strong> Attachment Created Time </strong> field and use the{" "}
          <strong>‘Age in Days’</strong> condition and set it to greater than{" "}
          <strong>90</strong> to avoid deleting recent attachments.
          <br />
          2. Select <strong> Status </strong> field and use <strong>‘=’</strong>{" "}
          condition and set it to <strong>success</strong>
          <br />
          These 2 conditions include attachments that have been successfully
          backed up to the drive. Attachments outside these conditions may lead
          to <strong>accidental data loss.</strong>
        </Alert>

        {/* Settings Cards */}
        <Box
          display="flex"
          flexWrap="wrap"
          gap={2}
          justifyContent="flex-start"
          sx={{ pb: 5 }}
        >
          {settings?.map((setting, index) => (
            <Paper
              key={index}
              sx={{
                width: 250,
                p: 3,
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                borderRadius: "10px",
                border: "1px solid #e0e0e0",
                boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.05)",
              }}
              elevation={0}
            >
              <Box fontWeight={600} fontSize="16px" mb={1.5}>
                {JSON.parse(setting?.setting_schema)?.name}
              </Box>

              <Chip
                label={
                  JSON.parse(setting?.setting_schema)
                    ?.sheduleDeleteViewAttachment?.displayLabel
                }
                sx={{
                  backgroundColor: "#F1F6FF",
                  color: "#333",
                  fontWeight: 500,
                  fontSize: "12px",
                  height: "24px",
                  mb: 1.5,
                  width: "fit-content",
                }}
              />

              <Box fontSize="14px" color="text.secondary" flexGrow={1} mb={3}>
                Deletes attachments from records in the "
                {
                  JSON.parse(setting?.setting_schema)
                    ?.sheduleDeleteViewAttachment?.displayLabel
                }
                " view based on your configured time rule.
              </Box>

              {/* <Button
                variant="text"
                color="error"
                onClick={() => {
                  deleteSettingById(setting?.setting_id);
                }}
                sx={{
                  backgroundColor: "#fff5f5",
                  border: "1px solid #ffecec",
                  color: "#f44336",
                  textTransform: "none",
                  fontWeight: 500,
                  borderRadius: "6px",
                  py: 1,
                }}
                fullWidth
              >
                Delete
              </Button> */}

              <DeleteAttachmentModal
                service={JSON.parse(setting?.setting_schema)}
                handleRevokeService={() => {
                  deleteSettingById(setting?.setting_id);
                }}
              />
            </Paper>
          ))}
        </Box>

        {/* Create Modal */}
        <CreateNewDeleteAttachmentSettingModal
          setReload={setReload}
          orgid={orgid}
          apikey={apikey}
          datacenterurl={datacenterurl}
          datacenter={datacenter}
          zuid={zuid}
          zapikey={zapikey}
          createNewSettingOpen={createNewSettingOpen}
          handleRevokeClose={handleRevokeClose}
        />
      </Box>
    </Box>
  );
}

export default RelatedListSetting;
